import express from 'express';
import { parsePayload } from '~/app/middleware';

import { callbackHandler } from '../middleware/Callback';
import { copyEntryField } from '../middleware/Fields';

const copyRouter = express.Router();

copyRouter.post(
  '/field{/:preview}',
  parsePayload,
  copyEntryField,
  callbackHandler
);

export default copyRouter;
